import { useContext, useEffect, useState } from "react";
import { eCONFIGCATEGORY, ePrivileges } from "../../../utils/enum";
import { UserContext } from "../../../context";
import Utils from "../../../utils";
import styles from "./config.module.css";
import ProductList from "./product/list";
import { TContext, TPrivilege } from "../../../types/config";
import FaultCategoryList from "./fault-category/list";
import StatorUsedList from "./stator-used/list";
import DefectLogBookList from "./defect-log-book/list";
import PasswordManager from "./password-manager/list";

function ConfigurationList() {
  const context: TContext = useContext(UserContext);
  const [activeEntity, setActiveEntity] = useState<string>("");

  useEffect(() => {
    setActiveEntity(
      Utils.isUserHasAccess(
        context.user?.privilegeList as TPrivilege[],
        ePrivileges.ADDEDITPRODUCT
      )
        ? eCONFIGCATEGORY.PRODUCTS
        : Utils.isUserHasAccess(
              context.user?.privilegeList as TPrivilege[],
              ePrivileges.ADDEDITFAULTCATEGORY
            )
          ? eCONFIGCATEGORY.FAULTCATEGORY
          : Utils.isUserHasAccess(
                context.user?.privilegeList as TPrivilege[],
                ePrivileges.ADDEDITSTATORUSED
              )
            ? eCONFIGCATEGORY.STATORUSED
            : Utils.isUserHasAccess(
                  context.user?.privilegeList as TPrivilege[],
                  ePrivileges.UPLOADDEFECTLOGBOOK
                )
              ? eCONFIGCATEGORY.DEFECTLOGBOOK
              : Utils.isUserHasAccess(
                    context.user?.privilegeList as TPrivilege[],
                    ePrivileges.UPDATEMOVETODRAFTPASSWORD
                  )
                ? eCONFIGCATEGORY.PASSWORDMANAGER
                : ""
    );
  }, [context?.user]);

  const clearQueryParams = () => {
    const baseUrl = window.location.origin + window.location.pathname;
    window.history.replaceState(null, "", baseUrl); // Replace URL without query params
  };

  return (
    <div>
      <div className={styles.parentContainer}>
        {/* Check if user has permission to view customer menu */}
        {Utils.isUserHasAccess(
          context.user?.privilegeList as TPrivilege[],
          ePrivileges.ADDEDITPRODUCT
        ) ? (
          <div
            className={`${styles.tab} ${
              activeEntity === eCONFIGCATEGORY.PRODUCTS ? styles.activeTab : ""
            }`}
            onClick={() => {
              clearQueryParams();
              setActiveEntity(eCONFIGCATEGORY.PRODUCTS);
            }}
          >
            <span
              className={
                activeEntity === eCONFIGCATEGORY.PRODUCTS
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Products
            </span>
          </div>
        ) : null}

        {Utils.isUserHasAccess(
          context.user?.privilegeList as TPrivilege[],
          ePrivileges.ADDEDITFAULTCATEGORY
        ) ? (
          <div
            className={`${styles.tab} ${
              activeEntity === eCONFIGCATEGORY.FAULTCATEGORY
                ? styles.activeTab
                : ""
            }`}
            onClick={() => {
              clearQueryParams();
              setActiveEntity(eCONFIGCATEGORY.FAULTCATEGORY);
            }}
          >
            <span
              className={
                activeEntity === eCONFIGCATEGORY.FAULTCATEGORY
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Fault Category
            </span>
          </div>
        ) : null}

        {Utils.isUserHasAccess(
          context.user?.privilegeList as TPrivilege[],
          ePrivileges.ADDEDITSTATORUSED
        ) ? (
          <div
            className={`${styles.tab} ${
              activeEntity === eCONFIGCATEGORY.STATORUSED
                ? styles.activeTab
                : ""
            }`}
            onClick={() => {
              clearQueryParams();
              setActiveEntity(eCONFIGCATEGORY.STATORUSED);
            }}
          >
            <span
              className={
                activeEntity === eCONFIGCATEGORY.STATORUSED
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Stator Used
            </span>
          </div>
        ) : null}

        {Utils.isUserHasAccess(
          context.user?.privilegeList as TPrivilege[],
          ePrivileges.UPLOADDEFECTLOGBOOK
        ) ? (
          <div
            className={`${styles.tab} ${
              activeEntity === eCONFIGCATEGORY.DEFECTLOGBOOK
                ? styles.activeTab
                : ""
            }`}
            onClick={() => {
              clearQueryParams();
              setActiveEntity(eCONFIGCATEGORY.DEFECTLOGBOOK);
            }}
          >
            <span
              className={
                activeEntity === eCONFIGCATEGORY.DEFECTLOGBOOK
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Defect Code Book
            </span>
          </div>
        ) : null}
        {/* Check if user has permission to view password manager menu */}

        {Utils.isUserHasAccess(
          context.user?.privilegeList as TPrivilege[],
          ePrivileges.UPDATEMOVETODRAFTPASSWORD
        ) ? (
          <div
            className={`${styles.tab} ${
              activeEntity === eCONFIGCATEGORY.PASSWORDMANAGER
                ? styles.activeTab
                : ""
            }`}
            onClick={() => {
              clearQueryParams();
              setActiveEntity(eCONFIGCATEGORY.PASSWORDMANAGER);
            }}
          >
            <span
              className={
                activeEntity === eCONFIGCATEGORY.PASSWORDMANAGER
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Password for Re-editing
            </span>
          </div>
        ) : null}
      </div>
      <div>
        {activeEntity === eCONFIGCATEGORY.PRODUCTS ? (
          <ProductList />
        ) : activeEntity === eCONFIGCATEGORY.FAULTCATEGORY ? (
          <FaultCategoryList />
        ) : activeEntity === eCONFIGCATEGORY.STATORUSED ? (
          <StatorUsedList />
        ) : activeEntity === eCONFIGCATEGORY.DEFECTLOGBOOK ? (
          <DefectLogBookList />
        ) : activeEntity === eCONFIGCATEGORY.PASSWORDMANAGER ? (
          <PasswordManager />
        ) : null}
      </div>
    </div>
  );
}

export default ConfigurationList;
